import styled from "styled-components";

export const Explore = styled.div`
  width: 100%;
  max-width: 550px;
  margin: auto;
  display: flex;
  flex-direction: column;
  height: 100vh; /* Full viewport height */
  background-color: #000; /* Optional, if your app uses dark theme */
`;

export const Header = styled.div`
  padding: 1.5rem 1rem 0.5rem;
  background-color: #000; /* Optional, to separate it visually */
  flex-shrink: 0;

  h1 {
    color: white;
    font-size: 28px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 0;
  }

  @media screen and (max-width: 600px) {
    padding: 1rem;

    h1 {
      font-size: 20px;
      text-align: center;
    }

    .input-wrapper {
      margin-bottom: 1rem;

      .explore-input {
        background: #000000;
        padding-left: 1rem;
        border-bottom: 0;
        height: 2.6rem;
        font-size: 18px;
        border-radius: 6px;
        opacity: 1;
      }
    }
  }
`;

export const ProfileWrapper = styled.div`
  flex: 1; /* Takes all remaining space */
  overflow-y: auto;
  padding: 0 1rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;

  -webkit-overflow-scrolling: touch; /* Smooth scroll on iOS */

  /* Optional scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #888 transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 3px;
  }
`;
